var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-ledger-account-autocomplete", {
            attrs: {
              value: _vm.start,
              fancy: "",
              label: _vm.$ct("ledger-account-from"),
            },
            on: {
              input: function ($event) {
                return _vm.setStart($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-ledger-account-autocomplete", {
            attrs: {
              value: _vm.end,
              fancy: "",
              label: _vm.$ct("ledger-account-to"),
            },
            on: {
              input: function ($event) {
                return _vm.setEnd($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }